module.exports = __webpack_public_path__ + "img/20200501_160424.be2823e6.jpg";